import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-badge',
    templateUrl: './badge.component.html',
    styleUrls: ['./badge.component.scss'],
    standalone: false
})
export class BadgeComponent {
  @Input({ required: true }) text!: string;
  @Input() bgClass = 'bg-secondary';
  @Input() tooltipMessage = '';
}
